import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  loading: {
    marginTop: '2rem',
    display: 'flex',
    justifyContent: 'space-around',
  },
  notFoundContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.colors.mediumDarkGrey,
  },
}));
